import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import {
  WorkOrderCorrectiveItemComment,
  WorkOrderRegularItemComment,
} from "src/util/types/dataModels/workOrderComment"

//region Types

export type WorkOrderCorrectiveItemCommentDocument = RxDocument<WorkOrderCorrectiveItemComment>
export type WorkOrderCorrectiveItemCommentCollection = RxCollection<WorkOrderCorrectiveItemComment>

export type WorkOrderRegularItemCommentDocument = RxDocument<WorkOrderRegularItemComment>
export type WorkOrderRegularItemCommentCollection = RxCollection<WorkOrderRegularItemComment>

//endregion

/**
 * Schema for work order corrective item comments collections
 */
export const workOrderCorrectiveItemCommentSchema: RxJsonSchema<WorkOrderCorrectiveItemComment> = {
  title: "Work Order Corrective Item Comments schema",
  description: "Collection of all work orders corrective item comments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    text: { type: "string", maxLength: 2048 },
    user: { type: "string", maxLength: 36 },
    work_order: { ref: "work_order_corrective_item", type: "string", maxLength: 36 },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "text", "user", "work_order"],
  indexes: ["work_order"],
}

/**
 * Schema for work order regular item comment collections
 */
export const workOrderRegularItemCommentSchema: RxJsonSchema<WorkOrderRegularItemComment> = {
  title: "Work Order Regular Item Comments schema",
  description: "Collection of all work orders regular item comments",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    text: { type: "string", maxLength: 2048 },
    user: { type: "string", maxLength: 36 },
    work_order: { ref: "work_order_regular_item", type: "string", maxLength: 36 },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "text", "user", "work_order"],
  indexes: ["work_order"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const workOrderCorrectiveItemCommentCollectionCreator: RxCollectionCreator = {
  schema: workOrderCorrectiveItemCommentSchema,
}

export const workOrderRegularItemCommentCollectionCreator: RxCollectionCreator = {
  schema: workOrderRegularItemCommentSchema,
}
